import memoize from 'lodash/memoize';
import { getComputedFont } from "./getComputedFont";
export const getSystemFontFamilyMap = memoize(() => {
  const computedSystemFont = getComputedFont({
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif'
  });
  return {
    base: computedSystemFont,
    upper: computedSystemFont,
    mono: getComputedFont({
      family: 'Menlo, Consolas, monospace'
    })
  };
});